import { createContext, useContext, useEffect, useState } from "react";
import { adminColors, adminColorsDark } from "@/theme";

const AdminThemeContext = createContext(null);
const KEY = "garlic_admin_dark";

export function AdminThemeProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem(KEY) === "1");
  useEffect(() => { localStorage.setItem(KEY, dark ? "1" : "0"); }, [dark]);
  const c = dark ? adminColorsDark : adminColors;
  return (
    <AdminThemeContext.Provider value={{ c, dark, toggle: () => setDark((d) => !d) }}>
      {children}
    </AdminThemeContext.Provider>
  );
}

export const useAdminTheme = () => useContext(AdminThemeContext);
